import { createApp } from 'vue'
import ElementPlus from 'element-plus'; // 引入 Element Plus
import 'element-plus/dist/index.css'; // 引入 Element Plus 的样式
import App from './App.vue'
import router from '@/router/index';
import './assets/tailwind.css'
import 'tailwindcss/tailwind.css';

// 设置默认页面title
document.title = '芝麻开花智能写作平台';

const app = createApp(App);

app.use(ElementPlus);
app.use(router); // 使用路由
app.mount('#app');
